import { makeStyles } from "@material-ui/core/styles";
import { BREAKPOINT_MD } from "../../../../util/Constants";

export const FORM_STYLES_V2 = "v2";

export const DISABLED_CONTROLS_BG = "transparent";
export const BORDER_RADIUS_FIELDS = 8;

export const BORDER_RADIUS_BLOCKS = 8;

export const FIELDS_HEIGHT = 36;
export const FIELDS_REPETITIVE_HEIGHT = 34;

const useStylesHook = makeStyles(() => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? "center"
        : "flex-start",
    width: "100%",
    minHeight: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? 30
        : "auto",
    flexDirection: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? "row"
        : "column",
    lineHeight: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? "default"
        : "1.3",
    marginBottom: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? "default"
        : 7,
  },
  label: {
    marginRight: "5px",
    fontSize: "1.1em",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    width: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? "30%"
        : "100%",
    height: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? 30
        : "auto",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "&:hover": {
      overflow: "unset",
      textDecoration: "underline",
    },
  },
  lockIcon: {
    display: "none",
  },
  children: {
    width: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? "70%"
        : "100%",
    display: "flex",
    justifyContent: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? "flex-end"
        : "flex-start",
    alignItems: "center",
    height: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD && "auto",
  },
}));

const useStylesV2Hook = makeStyles(() => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? "flex-start"
        : "flex-start",
    width: "100%",
    minHeight: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? 30
        : "auto",
    flexDirection: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? "column"
        : "column",
    lineHeight: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? "default"
        : "1.3",
    marginBottom: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD ? 16 : 16,
  },
  label: {
    marginRight: "5px",
    fontSize: "1.45em",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    width: "100%",
    height: "auto",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    "&:hover": {
      overflow: "unset",
      textDecoration: "underline",
    },
  },
  lockIcon: {
    marginBottom: 3,
  },
  children: {
    width: "100%",
    display: "flex",
    justifyContent: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD
        ? "flex-end"
        : "flex-start",
    alignItems: "center",
    height: (props) =>
      props.wd && props.wd.width && props.wd.width > BREAKPOINT_MD && "auto",
  },
}));

// Create a custom hook that returns the appropriate styles
export const useStyles = (props) => {
  const stylesV1 = useStylesHook(props);
  const stylesV2 = useStylesV2Hook(props);

  // Return the appropriate styles based on version
  return props.stylesVersion === FORM_STYLES_V2 ? stylesV2 : stylesV1;
};
